export const FocusInput = (el,binding,vnode) => {
	if(binding.value) {
		setTimeout(() => {
			vnode.elm.focus()
		}, 200);
	}
}
